import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${() => css`
    > ul {
      padding: 0.5rem 1.5rem 0.25rem;
    }
  `}
`;

export const LoadingWrapper = styled.div`
  ${() => css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 0;
    overflow: hidden;
  `}
`;

export const LoadMoreButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    width: 100%;
    padding: 0.5rem 1.5rem;
    border: none;
    background: transparent;
    cursor: pointer;
    font-size: 0.8125rem;
    font-weight: 600;
    color: ${theme.colors.brand.primary.default};
    transition: color ${theme.transition.default};

    svg {
      width: 0.875rem;
      height: 0.875rem;
    }

    :hover {
      color: ${theme.colors.brand.primary.hover};
    }
  `}
`;
